<template>
    <div class="top-tags">
        <div class="tags-body">
            <p><a href="#" @click="this.$router.push('/')">首页</a> > <a href="#" @click="this.$router.push('/About')">关于我们</a></p>
        </div>
    </div>
    <div class="zhu-about">
        <h3>关于我们</h3>
        <div class="about">
          <div class="about_us">

            <div class="about-logo">
              <img src = "../assets/img/logo/biglogo.jpg"/>
              
            </div>

            <div class="about-text">
                <div class="about-content">
                    <h2>开封政泉艺术品鉴定有限公司</h2>
					<br />
                    <p>&nbsp; &nbsp;&nbsp;&nbsp; 开封市政泉艺术品鉴定有限公司（简称政泉评级），是位于河南省开封市主要针对古钱币、银币进行鉴定评估的一家公司。
                    <br>&nbsp; &nbsp;&nbsp;&nbsp;公司设立在八朝古都开封，钱币文化底蕴深厚，氛围好，玩家众多。公司业务包含对历代古钱币、机制银币、机制铜元、杂项鉴定评估，每一枚钱币至少两位评级师进行鉴定评估，确保钱币鉴定结果的准确性。公司宗旨就是坚持初心、优化服务。专注严谨、公平公正。让每一位泉友能够放心购买钱币，为每一位泉友的藏品保驾护航。</p>
                    	<p>&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
                    	&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;--开封政泉艺术品鉴定有限公司</p>
                </div>
            </div>
          </div>
        </div>
    </div>

</template>

<style lang="scss" scoped>
//-------------------------------小跳转菜单
.top-tags {
    width: 100%;
    height: 40px;
    background: #f3f3f3;
    .tags-body {
        width: 1210px;
        margin: 0 auto;
        border: 1px solid #f3f3f3;
        text-align: left;
        position: relative;
        @media only screen and (max-width: 1210px) {
            width: 100%;
        }
        
        p {
            margin-top: 10px;
            padding-left: 5px;
            border-left: 6px solid #409EFF;
            
            a {
                color: #303133;
                font-size: 14px;
                text-decoration: none;
                &:hover {
                    color: #409EFF;
                }
            }
        }
    }
}



.zhu-about {
    width: 1400px;
    margin: 0 auto;
    @media only screen and (max-width: 1400px) {
        width: 100%;
    }
    h3 {
        @media only screen and (max-width: 810px) {
            width: 90%;
            margin: 20px 5%;
        }
        font-size: 24px;
        text-align: left;
        margin: 20px 96px;
        padding: 10px 0;
        border-bottom: 1px solid #DFDFDF;
        position: relative;
        &::after {
            content: "";
            position: absolute;
            left: 48px;
            bottom: -1px;
            width: 100px;
            height: 2px;
            margin-left: -50px;
            background-color: #409EFF;
        }
    }
    //-----------------------------------------------关于我们-----------------------------------------------

    .about {
        width: 1400px;
        margin: 0 auto;
        height: 450px;
        @media only screen and (max-width: 1400px) {
            width: 100%;
        }
        @media only screen and (max-width: 520px) {
            height: 500px;
        }
        @media only screen and (max-width: 420px) {
            height: 550px;
        }
        @media only screen and (max-width: 380px) {
            height: 650px;
        }
        
        h5 {
            margin-top: 30px;
        }

        .about_us {
        display: flex;
        @media only screen and (max-width: 1180px) {
            width: 100%;
            display: block;
        }
            .about-logo {
                width: 50%;
                @media only screen and (max-width: 1180px) {
                    width: 100%;
                }
                img {
                    margin-top: 30px;
                    margin-left: 150px;
                    width: 160px;
                    @media only screen and (max-width: 1179px) {
                        
                        margin: auto 0;
                    }
                }
            }

            .about-text {
                .about-content {
                    margin-top: 30px;
                    margin-left: 30px;
                    margin-bottom: 30px;
                    p {
                        font-size: 16px;
                        line-height: 35px;
                        color: #666666;
                        text-align: center;
                        word-break: break-all;
                        word-wrap: break-word;
                    }
                }
            }
        }
    }
    
}
</style>